import { render, staticRenderFns } from "./idiomasEditar.vue?vue&type=template&id=0baaf475&scoped=true&"
import script from "./idiomasEditar.vue?vue&type=script&lang=js&"
export * from "./idiomasEditar.vue?vue&type=script&lang=js&"
import style0 from "./idiomasEditar.vue?vue&type=style&index=0&id=0baaf475&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baaf475",
  null
  
)

export default component.exports